/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CheckCompanyByInvitationCodeResponse } from '../../models/check-company-by-invitation-code-response';

export interface CheckCompanyByInvitationCode$Params {
  invitationCode: string;
  resendOtp: boolean;
}

export function checkCompanyByInvitationCode(http: HttpClient, rootUrl: string, params: CheckCompanyByInvitationCode$Params, context?: HttpContext): Observable<StrictHttpResponse<CheckCompanyByInvitationCodeResponse>> {
  const rb = new RequestBuilder(rootUrl, checkCompanyByInvitationCode.PATH, 'get');
  if (params) {
    rb.query('invitationCode', params.invitationCode, {});
    rb.query('resendOtp', params.resendOtp, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CheckCompanyByInvitationCodeResponse>;
    })
  );
}

checkCompanyByInvitationCode.PATH = '/api/company/check-invitation-code';
